import React from 'react';

const PasswordChangeModal = (props) => {
    return (
        <div className="success-modal-overlay" onClick={props.handleOverlayClick}>
        <div className="success-modal">
            <div className="success-icon">

                {props.isSuccess?(   
                 <svg width="40" height="40" viewBox="0 0 40 40">
                    <circle cx="20" cy="20" r="19" fill="white" stroke="#4CAF50" strokeWidth="2"/>
                    <path d="M12 20l6 6 12-12" stroke="#4CAF50" strokeWidth="2" fill="none"/>
                </svg>
                ):props.isCompare?(
                    <svg width="40" height="40" viewBox="0 0 40 40">
                        <circle cx="20" cy="20" r="19" fill="white" stroke="#2196F3" strokeWidth="2"/>
                        <circle cx="20" cy="13" r="2.5" fill="#2196F3"/>
                        <rect x="18" y="18" width="4" height="12" fill="#2196F3" rx="1"/>
                    </svg>
                ):(
                  <svg width="40" height="40" viewBox="0 0 40 40">
                   <circle cx="20" cy="20" r="19" fill="white" stroke="#f44336" strokeWidth="2"/>
                   <path d="M12 12l16 16M28 12l-16 16" stroke="#f44336" strokeWidth="2" fill="none"/>
                </svg>
                )}
            </div>
            <p className="success-message">{props.message}</p>
            <button className="btn btn-primary" onClick={props.handleCloseModal}>
                OK
            </button>
        </div>
    </div>
    );
};

export default PasswordChangeModal;